import React, { useEffect, useState, useRef } from "react";
import { OverlayPanel } from "primereact/overlaypanel";
import { KeyboardDatePicker } from "@material-ui/pickers";
import { Badge, Card } from "react-bootstrap";
import CustomDataTable from "../../../../partials/content/CustomDataTable";
import Illustration from "../../../../partials/content/Illustration";
import { getSalesCardReport } from "../../../../services/crm/crmReportService";
import NumberFormat from "react-number-format";
import { useGlobalData } from "../../../../../provider/GlobalDataProvider";
import ResponsiveEllipsis from "../../../../partials/content/ResponsiveEllipsis";
import { DateTime } from "luxon";
function SalesCardReport(props) {
  const { reload, companyProfile } = useGlobalData();
  const [salesCard, setSalesCard] = useState([]);
  const selectParamOp = useRef(null);
  const [selectParam, setSelectParam] = useState({
    dateFrom: DateTime.fromISO(companyProfile.CreatedAt).startOf("day"),
    dateTo: DateTime.now().endOf("day"),
  });

  useEffect(() => {
    getSalesCardData();
  }, [reload]);

  return (
    <React.Fragment>
      <OverlayPanel
        ref={selectParamOp}
        showCloseIcon
        dismissable={false}
        id="overlay_panel"
        style={{ width: "450px" }}
        className="overlaypanel-demo"
      >
        <div className="row mb-3">
          <div className="col-sm-12 col-md-12 col-lg-12">
            <Card>
              <Card.Header>
                <i className="fas fa-filter"></i>
                <span>
                  <strong>Filter Selection</strong>
                </span>
              </Card.Header>
              <Card.Body>
                <div className="row">
                  <div className="col-6">
                    <KeyboardDatePicker
                      label="Date From"
                      autoOk
                      size="small"
                      inputVariant="outlined"
                      variant="inline"
                      margin="normal"
                      value={selectParam.dateFrom}
                      onChange={(date) => {
                        const selectParamTmp = { ...selectParam };
                        selectParamTmp.dateFrom = date;
                        setSelectParam(selectParamTmp);
                      }}
                      format="yyyy-MM-dd"
                      InputProps={{ readOnly: true }}
                    />
                  </div>
                  <div className="col-6">
                    <KeyboardDatePicker
                      label="Date To"
                      autoOk
                      size="small"
                      inputVariant="outlined"
                      variant="inline"
                      margin="normal"
                      value={selectParam.dateTo}
                      onChange={(date) => {
                        const selectParamTmp = { ...selectParam };
                        selectParamTmp.dateTo = date;
                        setSelectParam(selectParamTmp);
                      }}
                      minDate={selectParam.dateFrom}
                      format="yyyy-MM-dd"
                      InputProps={{ readOnly: true }}
                    />
                  </div>
                </div>
              </Card.Body>
            </Card>
          </div>
        </div>
        <div className="row">
          <div className="col-sm-12 col-md-12 col-lg-12">
            <button
              type="button"
              className="btn btn-success btn-md btn-pill btn-bold float-right"
              onClick={() => {
                getSalesCardData();
              }}
            >
              <i className="fas fa-search"></i>
              Get Sales Card
            </button>
          </div>
        </div>
      </OverlayPanel>
      {salesCard.length ? (
        <React.Fragment>
          <CustomDataTable
            data={salesCard}
            onRefreshData={() => {
              getSalesCardData();
            }}
            buttons={[
              {
                name: "Filter",
                onClick: (e) => {
                  selectParamOp.current.toggle(e);
                },
                icon: "fas fa-search",
                color: "info",
              },
            ]}
            columns={[
              {
                header: "Type",
                field: "customerTypeDesc",
                body: (rowData) => (
                  <React.Fragment>
                    <ResponsiveEllipsis
                      text={rowData.customerTypeDesc}
                      maxLine="1"
                    />
                  </React.Fragment>
                ),
                sortable: true,
                filter: true,
              },
              {
                header: "Name",
                field: "leadName",
                body: (rowData) => (
                  <React.Fragment>
                    {rowData.customerID > 0 ? (
                      <ResponsiveEllipsis
                        text={rowData.customerName}
                        maxLine="1"
                      />
                    ) : (
                      <ResponsiveEllipsis text={rowData.leadName} maxLine="1" />
                    )}
                  </React.Fragment>
                ),
                sortable: true,
                filter: true,
                hidden: true,
              },
              {
                header: "Name",
                field: "customerName",
                body: (rowData) => (
                  <React.Fragment>
                    {rowData.customerID > 0 ? (
                      <ResponsiveEllipsis
                        text={rowData.customerName}
                        maxLine="1"
                      />
                    ) : (
                      <ResponsiveEllipsis text={rowData.leadName} maxLine="1" />
                    )}
                  </React.Fragment>
                ),
                sortable: true,
                filter: true,
              },
              {
                header: "Pipeline Status",
                field: "pipelineStatusDesc",
                body: (rowData) => {
                  if (rowData.pipelineStatus === 9999) {
                    return (
                      <Badge variant="success">
                        {rowData.pipelineStatusDesc}
                      </Badge>
                    );
                  } else if (rowData.pipelineStatus === 9998) {
                    return (
                      <Badge variant="danger">
                        {rowData.pipelineStatusDesc}
                      </Badge>
                    );
                  } else if (rowData.pipelineStatus < 9998) {
                    return (
                      <Badge variant="info">{rowData.pipelineStatusDesc}</Badge>
                    );
                  } else {
                    return (
                      <Badge variant="dark">{rowData.pipelineStatusDesc}</Badge>
                    );
                  }
                },
                sortable: true,
                filter: true,
              },
              {
                header: "Currency",
                field: "currencyCode",
                body: null,
                sortable: true,
                filter: true,
                hidden: true,
              },
              {
                header: "Estimation Value",
                field: "estValue",
                body: (rowData) => (
                  <NumberFormat
                    value={rowData.estValue}
                    displayType={"text"}
                    thousandSeparator={true}
                    renderText={(value) => (
                      <div className="float-right">
                        {rowData.currencyCode} {value}
                      </div>
                    )}
                  />
                ),
                sortable: true,
                filter: true,
              },
              {
                header: "Quotation ID",
                field: "quotationID",
                body: null,
                sortable: true,
                filter: true,
              },
              {
                header: "Quotation Value",
                field: "quotationValue",
                body: (rowData) => (
                  <NumberFormat
                    value={rowData.quotationValue}
                    displayType={"text"}
                    thousandSeparator={true}
                    decimalScale={2}
                    renderText={(value) => (
                      <div className="float-right">
                        {rowData.currencyCode} {value}
                      </div>
                    )}
                  />
                ),
                sortable: true,
                filter: true,
              },
            ]}
          />
        </React.Fragment>
      ) : (
        <React.Fragment>
          <Illustration
            imageSource="INVIFO CRM.png"
            description={`You don't have any Sales Card for current data selection!`}
            guidance={`Hint: Try to filter another data selection to get some results`}
            descriptionLeftIcon="fas fa-info-circle kt-font-info"
            size="md"
          ></Illustration>
          <div className="text-center py-3">
            <button
              type="button"
              className="btn btn-info btn-md btn-pill btn-bold mx-1"
              onClick={(e) => {
                selectParamOp.current.toggle(e);
              }}
            >
              <i className="fas fa-search"></i>
              Filter
            </button>
          </div>
        </React.Fragment>
      )}
    </React.Fragment>
  );

  async function getSalesCardData() {
    const response = await getSalesCardReport(
      selectParam.dateFrom,
      selectParam.dateTo
    );
    const { data } = response.data;
    setSalesCard(data.salesCardReport);
  }
}

export default SalesCardReport;
